
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/document-text","xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#697485"}},[_c('path',{attrs:{"d":"M13.748 20.848H8.252c-2.538 0-4.257-.537-5.41-1.69s-1.69-2.872-1.69-5.41V8.252c0-2.538.537-4.257 1.69-5.41s2.872-1.69 5.41-1.69h4.58a.687.687 0 01.687.687.687.687 0 01-.687.687h-4.58c-2.15 0-3.56.409-4.438 1.287S2.526 6.102 2.526 8.252v5.5c0 2.15.409 3.56 1.287 4.438s2.289 1.284 4.439 1.284h5.5c2.15 0 3.56-.409 4.438-1.287s1.284-2.285 1.284-4.439v-4.58a.687.687 0 011.374 0v4.581c0 2.538-.537 4.257-1.69 5.41s-2.872 1.689-5.41 1.689z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M20.157 9.902h-3.686c-3.15 0-4.377-1.223-4.377-4.373V1.843a.691.691 0 01.427-.641.691.691 0 01.753.15l7.37 7.374a.691.691 0 01-.487 1.176zm-6.681-6.39v2.017c0 2.379.616 2.995 2.995 2.995h2.018z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11.935 12.607H6.406a.691.691 0 01-.691-.691.691.691 0 01.691-.691h5.529a.691.691 0 01.691.691.691.691 0 01-.691.691zM10.097 16.273H6.411a.691.691 0 01-.691-.691.691.691 0 01.691-.691h3.686a.691.691 0 01.691.691.691.691 0 01-.691.691z","opacity":".4"}})])])
          )
        }
      }
    